(function () {
  'use strict';

  var root, itemsEl, subtotalEl, checkoutEl, panelEl;
  var isHe = document.documentElement.getAttribute('dir') === 'rtl';
  var busy = false;

  var T = isHe
    ? { title: 'סל קניות', close: 'סגירה', empty: 'הסל ריק', subtotal: 'סה"כ ביניים', note: 'משלוח ומסים מחושבים בקופה', checkout: 'המשך לצ׳קאאוט', remove: 'הסרה' }
    : { title: 'Cart', close: 'Close', empty: 'Your cart is empty', subtotal: 'Subtotal', note: 'Shipping & taxes calculated at checkout', checkout: 'Continue to checkout', remove: 'Remove' };

  // Shopify's money_format is injected by the header so prices here match the
  // rest of the storefront instead of being guessed from the currency code.
  function formatMoney(cents) {
    var fmt = window.SORRY_MONEY_FORMAT || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,
        parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build() {
    root = document.createElement('div');
    root.className = 'cart-drawer';
    root.setAttribute('data-cart-drawer', '');
    root.hidden = true;
    root.innerHTML =
      '<div class="cart-drawer--backdrop" data-cart-drawer-close></div>' +
      '<aside class="cart-drawer--panel" role="dialog" aria-modal="true" aria-label="' + esc(T.title) + '">' +
        '<div class="cart-drawer--head">' +
          '<h2 class="cart-drawer--title">' + esc(T.title) + '</h2>' +
          '<button type="button" class="cart-drawer--close" data-cart-drawer-close aria-label="' + esc(T.close) + '">&times;</button>' +
        '</div>' +
        '<div class="cart-drawer--items" data-cart-drawer-items></div>' +
        '<div class="cart-drawer--foot">' +
          '<div class="cart-drawer--subtotal"><span>' + esc(T.subtotal) + '</span><span data-cart-drawer-subtotal></span></div>' +
          '<p class="cart-drawer--note">' + esc(T.note) + '</p>' +
          '<a class="cart-drawer--checkout" href="/cart" data-cart-drawer-checkout>' + esc(T.checkout) + '</a>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(root);

    panelEl = root.querySelector('.cart-drawer--panel');
    itemsEl = root.querySelector('[data-cart-drawer-items]');
    subtotalEl = root.querySelector('[data-cart-drawer-subtotal]');
    checkoutEl = root.querySelector('[data-cart-drawer-checkout]');
  }

  function render(cart) {
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer--empty">' + esc(T.empty) + '</div>';
      subtotalEl.textContent = formatMoney(0);
      checkoutEl.setAttribute('aria-disabled', 'true');
      return;
    }

    checkoutEl.removeAttribute('aria-disabled');

    // Every line is keyed by its own variant id, so two sizes of the same
    // product stay two rows. Shopify only merges lines that are the exact
    // same variant, which is the behaviour we want.
    itemsEl.innerHTML = cart.items.map(function (item) {
      var variantLabel = '';
      if (item.options_with_values) {
        variantLabel = item.options_with_values.map(function (o) {
          return esc(o.name) + ': ' + esc(o.value);
        }).join(' / ');
      } else if (item.variant_title) {
        variantLabel = esc(item.variant_title);
      }

      var img = item.image
        ? '<img src="' + esc(item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2')) + '" alt="">'
        : '';

      return '' +
        '<div class="cart-drawer--line" data-key="' + esc(item.key) + '">' +
          '<div class="cart-drawer--thumb">' + img + '</div>' +
          '<div class="cart-drawer--info">' +
            '<div class="cart-drawer--name">' + esc(item.product_title) + '</div>' +
            (variantLabel ? '<div class="cart-drawer--variant">' + variantLabel + '</div>' : '') +
            '<div class="cart-drawer--line-bottom">' +
              '<div class="cart-drawer--stepper">' +
                '<button type="button" data-cart-dec aria-label="-">&minus;</button>' +
                '<span class="cart-drawer--qty">' + item.quantity + '</span>' +
                '<button type="button" data-cart-inc aria-label="+">+</button>' +
              '</div>' +
              '<span class="cart-drawer--price">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-drawer--remove" data-cart-remove>' + esc(T.remove) + '</button>' +
          '</div>' +
        '</div>';
    }).join('');

    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function syncCounts(cart) {
    Array.prototype.forEach.call(document.querySelectorAll('.number-wrapper'), function (wrap) {
      var num = wrap.querySelector('.number');
      if (num) num.textContent = cart.item_count;
      wrap.classList.toggle('hide', cart.item_count === 0);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        syncCounts(cart);
        return cart;
      });
  }

  function open() {
    root.hidden = false;
    // Force a reflow so the transform transition actually runs.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(function () { root.hidden = true; }, 250);
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        syncCounts(cart);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function addFromForm(form) {
    var data = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    });
  }

  function boot() {
    build();

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }
      var line = e.target.closest('.cart-drawer--line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.cart-drawer--qty');
      var qty = parseInt(qtyEl.textContent, 10) || 1;

      if (e.target.closest('[data-cart-inc]')) changeLine(key, qty + 1);
      else if (e.target.closest('[data-cart-dec]')) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    // Header cart icon / link: open the drawer instead of navigating away.
    // The drawer's own Checkout button still goes to the cart page.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (!link) return;
      if (link.closest('.cart-drawer')) return;
      e.preventDefault();
      fetchCart().then(open);
    });

    // Intercept every add-to-cart form (product page included) so the page
    // never reloads or jumps to the top; the drawer opens in place instead.
    // Capture phase + stopImmediatePropagation keeps the theme's own jQuery
    // handler from also firing and double-adding.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(form)
        .then(fetchCart)
        .then(open)
        .catch(function () { form.submit(); });
    }, true);

    // Quick-add posts to the Cart API itself and then fires this.
    document.addEventListener('cart:added', function () {
      fetchCart().then(open);
    });
  }

  window.CartDrawer = {
    open: function () { return fetchCart().then(open); },
    close: close,
    refresh: fetchCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
